import { RegisterForm } from '../../components/auth/RegisterForm';

export function RegisterPage() {
  return (
    <div style={{
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      minHeight: 'calc(100vh - var(--header-height) - 120px)',
    }}>
      <RegisterForm />
    </div>
  );
}
